import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { emptyObj } from '@beef/utils';
import { createSelector } from '@reduxjs/toolkit';
import { createMergedBlockSelector } from "../../selectors";
import { getAddressBlock, getAnalyticEventType } from "../selectors";
import { getViewStatus } from "./moduleSelectors";
var getAddressBlockData = createMergedBlockSelector(getAddressBlock);
export var selectCurrentViewTexts = createSelector([getAddressBlockData, getViewStatus], function (texts, status) {
  return texts[status] || emptyObj;
});
export var selectContainerData = createSelector([selectCurrentViewTexts], function (_ref) {
  var _ref$img = _ref.img,
    img = _ref$img === void 0 ? {} : _ref$img,
    title = _ref.title,
    subtitle = _ref.subtitle;
  return {
    /** в компоненте InfoCard нет проверки на массив */
    img: Array.isArray(img === null || img === void 0 ? void 0 : img.source) ? _objectSpread({}, img) : _objectSpread(_objectSpread({}, img), {}, {
      source: []
    }),
    title: title,
    text: subtitle
  } || emptyObj;
});
export var selectInputDebounce = createSelector([selectCurrentViewTexts], function (texts) {
  return texts.debounceTime;
});
export var selectInputPlaceholder = createSelector([selectCurrentViewTexts], function (texts) {
  return texts.inputPlaceholder;
});
export var selectInputError = createSelector([selectCurrentViewTexts], function (texts) {
  return texts.inputErrorText;
});
export var selectButtonTexts = createSelector([selectCurrentViewTexts], function (_ref2) {
  var buttonText = _ref2.buttonText,
    secondaryButtonText = _ref2.secondaryButtonText;
  return {
    buttonText: buttonText,
    secondaryButtonText: secondaryButtonText
  };
});
export var selectLink = createSelector([selectCurrentViewTexts], function (texts) {
  return texts.link;
});
export var selectAnchorId = createSelector([selectCurrentViewTexts], function (texts) {
  return texts.anchorId || 'tariffs2022';
});
export var selectCaptchaTexts = createSelector([getAddressBlockData], function (texts) {
  return texts.captchaTexts;
});
export var selectAddressVerificationAnalyticsData = createSelector([selectButtonTexts, selectCurrentViewTexts, getAnalyticEventType], function (_ref3, _ref4, pageType) {
  var _ref3$buttonText = _ref3.buttonText,
    buttonText = _ref3$buttonText === void 0 ? '' : _ref3$buttonText;
  var _ref4$title = _ref4.title,
    title = _ref4$title === void 0 ? '' : _ref4$title;
  return {
    buttonText: buttonText,
    title: title,
    pageType: pageType
  };
});